// Selectors


import { RootState } from '../../store';

export const genericRequestSelector = (state: RootState) => state.genericRequestState;
